.emptyBlock {
  padding: 70px 30px;
  max-width: 650px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.emptyText {
  padding: 10px 0;
  font-size: 15px;
  font-weight: normal;
  opacity: 0.5;
}
